import type { CartItemType } from '@/store/types/cart'
import type { GlobalStoreValues } from '@/store/useGlobalStore'
import { sendGTMEvent } from '@next/third-parties/google'
import { getEcommerceObjectFromCart } from '../../helpers/getEcommerceObjectFromCart'
import { gtmClearEcommerceData } from '../../helpers/clearEcommerceData'

type Props = {
  globalStore: GlobalStoreValues
  cart: CartItemType[]
}

export const gtmStartCheckout = ({ globalStore, cart }: Props) => {
  const uuid = crypto.randomUUID()

  gtmClearEcommerceData()

  sendGTMEvent({
    event: 'begin_checkout',
    event_id: uuid,
    ecommerce: getEcommerceObjectFromCart({ globalStore, cart }),
  })
}
